var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.888 15.5833V11.3667C25.888 9.31315 25.888 8.28637 25.4884 7.50204C25.1369 6.8121 24.5759 6.25117 23.886 5.89965C23.1017 5.5 22.0749 5.5 20.0214 5.5H13.4214C11.3678 5.5 10.3411 5.5 9.55672 5.89965C8.86679 6.25117 8.30586 6.8121 7.95434 7.50204C7.55469 8.28637 7.55469 9.31315 7.55469 11.3667V32.6333C7.55469 34.6868 7.55469 35.7137 7.95434 36.498C8.30586 37.1879 8.86679 37.7489 9.55672 38.1003C10.3411 38.5 11.3678 38.5 13.4214 38.5H17.638M7.55469 23.8333H16.7214M7.55469 31.1667H16.7214M20.388 14.6667L13.0547 14.6667M16.7214 11V18.3333M33.588 24.75C33.588 26.2687 32.3568 27.5 30.838 27.5C29.3193 27.5 28.088 26.2687 28.088 24.75C28.088 23.2313 29.3193 22 30.838 22C32.3568 22 33.588 23.2313 33.588 24.75ZM36.888 38.5V37.5833C36.888 35.0521 34.836 33 32.3047 33H29.5547C27.0234 33 24.9714 35.0521 24.9714 37.5833V38.5H36.888Z",
    stroke: "#0796A7",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainIcon1);
export default __webpack_public_path__ + "static/media/main_icon1.912082767e8871123b133c0273b9bf74.svg";
export { ForwardRef as ReactComponent };